import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useToast } from "@/components/ui/use-toast";
import { useMutationWithErrorHandling } from "@/hooks/useMutationWithErrorHandling";
import { resetUserPassword } from "@/services/users";

export function useResetUserPassword(userId: string) {
  const { t } = useTranslation();
  const { toast } = useToast();

  const mutation = useMutationWithErrorHandling({
    mutationFn: () => resetUserPassword(userId),
    onSuccess: () => {
      toast({
        title: t("resetPasswordByAdmin.success"),
      });
    },
    errorTitle: t("resetPasswordByAdmin.error"),
  });

  const onConfirm = useCallback(() => {
    mutation.mutate(undefined);
  }, [mutation]);

  return {
    onConfirm,
    isPending: mutation.isPending,
  };
}
